import React from "react";
import { useParams } from "react-router-dom";
import useFileDocuments from "../actions/useFileDocuments";
import SearchFIles from "./SearchFIles";
import { Button } from "primereact/button";
import CustomeButton from "~/components/Button";

const RequestFileDocuments = () => {
  const { id, service_id, type, request_type, request_id } = useParams();
  const {
    states,
    fileName,
    setFileName,
    rows,
    first,
    onPageChange,
    handleOpenRequest,
  } = useFileDocuments({ id, service_id, type, request_type, request_id });
  return (
    <>
      {!states.loading && (
        <>
          <CustomeButton
            onClick={handleOpenRequest}
            label="Open Request"
            className="cancel-btn ml-auto mb-3"
            icon="pi pi-external-link"
            iconPos="right"
          />
          <SearchFIles
            fileName={fileName}
            setFileName={setFileName}
            additionaltag={{ entity: [states?.entity_detail?.name] }}
            states={states}
            first={first}
            rows={rows}
            onPageChange={onPageChange}
          />
        </>
      )}
    </>
  );
};

export default RequestFileDocuments;
